module.exports = __webpack_public_path__ + "img/five3Green.d704d368.jpg";